/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';
import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  lowerCaseAllWordsExceptFirstLetters,
  upperCaseFirstLetter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Grid,
} from '@material-ui/core';
import {
  dispatchQtrRange,
  dispatchErrorMsgCurrent,
  dispatchPerformResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  getInvoiceComparisonReport,
  dispatchRebateProgramName,
  dispatchInvoiceComparison,
  dispatchDisplayObjCurrent,
} from '../Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
} from '../../../../SharedModules/Errors/constantMessageData';

import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const RequestCurrentToPrevious = (props) => {
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const {
    performResolutionObj: requestCurrentDisData,
    planType: planTypeList,

    rebateProgramName: getRebateProgramName,
    errorMsgCurrent: getErrorMsg,
    quarterFrom: getQuarter,
    selectedPlanType,
    invoiceComparison: getInvoicecomparison,
  } = useSelector((state) => state?.sharedState?.CurrentPreviousQuarter);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const [radioList, setRadioList] = React.useState([]);

  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const dispatch = useDispatch();
  const [startQtr, setStartQtr] = React.useState(getQuarter);

  const [isSearchClicked, setSearchClicked] = React.useState(false);
  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd:
            getRebateProgramName || userDefaults?.rebateProgramCd
              ? userDefaults?.rebateProgramCd
              : '-1',
          startQtr: '',
        }
  );

  // dispatch function
  const setPerformScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    let getRebateProgramList = await dispatch(getRebateProgrameList(planType));
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);

  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  //Resetting Error message on change
  React.useEffect(() => {
    dispatch(dispatchErrorMsgCurrent([]));
  }, [state.planTypeCd, state.rebateProgramCd, startQtr])
  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCurrent(unique));
  };
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'startQtr') {
      value = autoFormateDate(data);
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'startQtr',
              errorType: 'startQtrRequired',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'startQtr',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'startQtr');
          setStartQtr(value?.toUpperCase());
        } else {
          localErr = localErr.filter((item) => item.field !== 'startQtr');
          localErr.push({
            field: 'startQtr',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'startQtr');
        if (type === 'startQtr') {
          localErr.push({
            field: 'startQtr',
            errorType: 'startQtrRequired',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCurrent(unique));
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/currentToPreviousQuarterInvoiceComparison', true);
    } else {
      tabHighLigther('/currentToPreviousQuarterInvoiceComparison', false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  //Search button on click functionality
  const onClickOnSearch = () => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr = getErrorMsg || [];
    if (!startQtr) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'startQtr');
      localErr.push({
        field: 'startQtr',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCurrent(unique));
    if (localErr.length == 0) {
      dispatch(dispatchInvoiceComparison([]));
      setSearchClicked(true);
      dispatch(
        getInvoiceComparisonReport({
          rebateProgram: rebateProgramName?.rebateProgramCd,
          quarter: startQtr,
        })
      );
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchQtrRange(startQtr));
      dispatch(
        dispatchDisplayObjCurrent({
          rebateProgramName,
          quarterFrom: startQtr,
        })
      );
    }
  };
  if (
    isSearchClicked &&
    getInvoicecomparison?.invoiceComparisonReportVO?.length > 0
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayCurrentToPreviousQuarterInvoiceComparison',
      value: 'Display Current to Previous Quarter Invoice',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displayCurrentToPreviousQuarterInvoiceComparison',
    });
    props.history.push({
      pathname: '/displayCurrentToPreviousQuarterInvoiceComparison',
    });
    dispatch(
      clearReduxForFilterAndSort(
        '/displayCurrentToPreviousQuarterInvoiceComparison'
      )
    );
  }

  //setting Quarter From
  const handlefromChange = (event) => {
    let value = event.target.value;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    setStartQtr(value);

    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'startQtr');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgCurrent(unique));
  };

  return (
    <div
      className="tabs-container  tBillPanel custom-check"
      data-testid="program-and-eligibility"
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Current to Previous Quarter Invoice Comparison"
      />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          }
        />
      ) : null}

      <div className="row">
        <div className="col-4 frr-two-col-radio">
          <RadioGroupComponent
            data-testid="radio-button-for-rcdd1"
            id="radio-button-for-rcdd_id"
            labelName="Plan Type"
            required
            optionList={radioList || []}
            defaultValue={state && state.planTypeCd}
            filterAction={(e) => {
              handleOnChangeEvent(e, 'planTypeCd');
            }}
            className="log-batch-filter-radio frr-checkInvoiceRadio"
          />
        </div>
        <div className="col-4 frr-two-col-radio ">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Rebate Program<span className="mandatory"> *</span>
            </legend>
            <div className="form-wrapper p-3">
              <div className="mui-custom-form with-select field-xl no-lbl">
                <TextField
                  name="rebateProgram"
                  id="rebate_program"
                  label="Rebate Program"
                  data-testid="radio-button-for-rebtprgm"
                  fullWidth
                  select
                  required
                  inputProps={{ maxLength: 11, id: 'rebate_program' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd'
                            ? 'mandate-fields'
                            : null
                        )
                      : null
                  }
                  onBlur={(e) =>
                    handleOnblurEvent('rebateProgramCd', e.target.value)
                  }
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                  }
                  value={
                    state && state.rebateProgramCd ? state.rebateProgramCd : ''
                  }
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                >
                  <MenuItem
                    selected
                    key="Please Select One"
                    value="-1"
                  ></MenuItem>
                  {rebateProgramList &&
                  rebateProgramList.length &&
                  rebateProgramList.length > 0
                    ? rebateProgramList.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="col-4 frr-two-col-radio">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Quarter<span className="mandatory"> *</span>
            </legend>
            <div className="form-wrapper p-3">
              <div className="mui-custom-form with-select field-xl no-lbl">
                <TextField
                  id="check_by_invoice_quater"
                  label="check_by_invoice_quater"
                  data-testid="reqCashReceipt-to"
                  required
                  fullWidth
                  value={startQtr}
                  onChange={handlefromChange}
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'startQtr' ? 'mandate-fields' : null
                        )
                      : null
                  }
                  onBlur={(e) => handleOnblurEvent('startQtr', e.target.value)}
                  helperText={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field === 'startQtr' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getErrorMsg?.length > 0
                      ? _.map(getErrorMsg, (l) =>
                          l.field == 'startQtr' ? l.message : null
                        )
                      : null
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      <div className="col-12 btn-wrapper mb-2">
        <div className="float-right mt-2 hide-on-print">
          <Button
            className="btn btn-success btn-search"
            data-testid="view_detail_ia"
            type="button"
            onClick={onClickOnSearch}
          >
            {' '}
            <SVGComponent iconName="Icon-search" /> {'  '} Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RequestCurrentToPrevious;
